import "./DashboardProductsSkeleton.css";

function Skeleton({ className = "" }) {
  return <div className={`skeleton ${className}`} />;
}

export default function ProductsPageSkeleton({
  productCount = 8,
}) {
  return (
    <div className="products-page-skeleton" dir="rtl">

  
      <div className="skeleton-home-layout-dashboard">    

        {/* ================= CONTENT ================= */}
        <main className="skeleton-products-content">     

          {/* Product grid */}
          <div className="skeleton-products-grid">

            {Array.from({ length: productCount }).map((_, index) => (
              <ProductCardSkeleton key={index} />
            ))}

          </div>   

    
        </main>
      </div>
    </div>
  );
}


/* =====================================================
   PRODUCT CARD
===================================================== */

function ProductCardSkeleton() {
  return (
    <div className="skeleton-product-card">

      {/* Image */}
      <Skeleton className="skeleton-product-image" />

      {/* Badge */}
      <Skeleton className="skeleton-product-badge" />

      {/* Brand */}
      <Skeleton className="skeleton-product-brand" />

      {/* Title */}
      <div className="skeleton-product-title">
        <Skeleton />
        <Skeleton />
      </div>

      {/* Rating */}
      <div className="skeleton-product-rating">
        <Skeleton />
        <Skeleton />
      </div>

      {/* Price */}
      <div className="skeleton-product-price">
        <Skeleton className="skeleton-old-price" />
        <Skeleton className="skeleton-current-price" />
      </div>

      {/* Cart */}
      <Skeleton className="skeleton-cart-button" />

    </div>
  );
}